module.exports = __webpack_public_path__ + "static/img/CEE.9ec08626.jpg";